import {
  checkNull,
  CodeList,
  RenderTextWithContainerPattern,
  ReportContainer,
} from "../constant";

interface AssessmentBlockProps {
  data: any;
}

const AssessmentBlock = ({ data }: AssessmentBlockProps) => {
  return (
    <>
      <RenderTextWithContainerPattern
        label="Assessment"
        val={data?.assessmentFreeNote}
      />
      {/* Header and code alignment mirror the Psychiatric Progress Exam report
          so the Assessment section reads the same across every note type. */}
      {checkNull(data?.assessmentCodes) && (
        <ReportContainer label="ICD Code">
          <CodeList codes={data?.assessmentCodes} />
        </ReportContainer>
      )}
    </>
  );
};

export default AssessmentBlock;
